// extracted by mini-css-extract-plugin
export var dropdownButton = "_34-0";
export var fullWidthDropdownButton = "_34-1";
export var icon = "_34-3";
export var iconPlaceholder = "_34-2";
export var menuItemRow = "_34-9";
export var separator = "_34-e";
export var shortcutContainer = "_34-7";
export var shortcutContainerFilled = "_34-8";
export var shortcutIconLg = "_34-6";
export var shortcutIconMd = "_34-5";
export var shortcutIconSm = "_34-4";
export var submenuChevron = "_34-d";
export var submenuDropdown = "_34-a";
export var submenuTriggerRow = "_34-b";
export var submenuTriggerRowOpen = "_34-c";